import { render, staticRenderFns } from "./NewCaptureForm.vue?vue&type=template&id=d09559c2&scoped=true"
import script from "./NewCaptureForm.vue?vue&type=script&lang=js"
export * from "./NewCaptureForm.vue?vue&type=script&lang=js"
import style0 from "./NewCaptureForm.vue?vue&type=style&index=0&id=d09559c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09559c2",
  null
  
)

export default component.exports